import snakecaseKeys from 'snakecase-keys';
import { OfferRequisition } from '../../../../entities/v1/applicant_tracking/OfferRequisition';
import { ApiService } from '../../../ApiService';

interface Params {
  expand?: string[];
}

export interface ShowParams extends Params {
  id: string;
}

export class OfferRequisitionService {
  public static show(params: ShowParams): Promise<OfferRequisition> {
    return ApiService.get<OfferRequisition>(
      `/api/v1/applicant_tracking/offer_requisitions/${params.id}`,
      snakecaseKeys(params),
    );
  }

  public static approve(id: number): Promise<void> {
    return ApiService.put<void>(
      `/api/v1/applicant_tracking/offer_requisitions/${id}/approve`,
    );
  }

  public static decline(id: number, declineReason: string): Promise<void> {
    return ApiService.put<void>(
      `/api/v1/applicant_tracking/offer_requisitions/${id}/decline`,
      snakecaseKeys({ declineReason }),
    );
  }

  public static sendReminder(id: number): Promise<void> {
    return ApiService.post<void>(
      `/api/v1/applicant_tracking/offer_requisitions/${id}/send_reminder`,
    );
  }
}
